<div *transloco="let t;" class="h-full relative flex ">
    <!-- BETA LOGO -->
    <div class="absolute top-0 left-0 z-20 pointer-events-none">
        <img class="w-32" src="./assets/img/Home/Label-Beta.png" />
    </div>
    <div class="flex relative w-full h-full">
        <k-side-menu [navigationList]="userNavigation" [userWallet]="userData.recordedWallet"
            (item)="onItemClick($event)" (onWalletClick)="copyToClipboard($event)" (onLogOutClick)="logOut()"
            (onPlayClick)="goToPlay()"></k-side-menu>
        <div class="w-full flex flex-col overflow-auto">
            <!-- OVERLAY TO CLOSE SIDE MENU -->
            <div *ngIf="!isMenuCollapsed"
                class="absolute bg-black bg-opacity-50 w-full h-full overlay md:hidden cursor-pointer "
                (click)="closeMenu()" style="z-index: 9;">
                <fa-icon class="absolute top-4 left-64" [icon]="'times'" size="2x"></fa-icon>
                <!-- <span class="absolute top-4 left-64">X</span> -->
            </div>
            <!-- TOP BAR -->
            <div class="nav-bar items-center justify-end flex pl-18" click-out-directive
                (isClickOutside)='clickOutsideNavbar($event)'>
                <notifications class="mr-auto"></notifications>
                <div id="balance-item-container" class="flex overflow-x-scroll mr-2 items-end">
                    <ng-container *ngFor="let item of balanceItems">
                        <balances-item class="mr-3" [data]="item" [isFocus]="ingameItemFocus.get(item.key)"
                            (onItemClick)="onBalanceItemClick($event)">
                        </balances-item>
                    </ng-container>
                </div>
                <div *ngIf="showQuickPurchase" id="quick-purchase-container" class="absolute" [style]="'top: 80px;'">
                    <k-card-content>
                        <div class="w-56 h-12 flex items-center ">
                            <quick-purchase [data]="quickPurchaseItem" class="w-full"></quick-purchase>
                        </div>
                    </k-card-content>
                </div>
            </div>
            <!-- PAGE CONTAINER -->
            <div class="w-full h-full overflow-y-auto page-container">
                <router-outlet *ngIf="true"></router-outlet>
            </div>
        </div>
    </div>
    <language-switch class="fixed z-20" [style]="isMenuCollapsed?'bottom: 14rem;':'bottom: 178px;'"></language-switch>
</div>
<p-toast key="session-expired" position="bottom-center" (onClose)="onSessionExpired()"></p-toast>